import template from './surveys_setup.html';
import tr from '../../lib/default-translator.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';

class SurveysSetupViewModel
{
	constructor(page)
	{
		this.page = page;
		this.surveys = ko.observableArray();
		this.anonymous_surveys = ko.observableArray();
	}

	async add_survey()
	{
		await Grape.dialog.open('SurveySetupAdd', {survey_id: null, anonymous: false});
		this.page.updateData();
	}

	async add_anonymous_survey()
	{
		await Grape.dialog.open('SurveySetupAdd', {survey_id: null, anonymous: true});
		this.page.updateData();
	}

	async edit_survey(data)
	{
		let value = ko.toJS(data);
		await Grape.dialog.open('SurveySetupAdd', {data: value, anonymous: false});
		this.page.updateData();
	}

	async edit_anonymous_survey(data)
	{
		let value = ko.toJS(data);
		await Grape.dialog.open('SurveySetupAdd', {data: value, anonymous: true});
		this.page.updateData();
	}

	async add_questions(data)
	{
		let value = ko.toJS(data);
		await Grape.dialog.open('SurveySetupQuestionsAdd', {data: value});
		this.page.updateData();
	}

	async edit_segments()
	{
		await Grape.dialog.open('EditSurveySegmentsPage');
		this.page.updateData();
	}

	async send_survey(data)
	{
		let value = ko.mapping.toJS(data);
		value.emp_not_log_in = false;
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Send this survey?'), message: tr('After a survey is sent, you will not be able to edit the questions'), accept_text: 'Proceed', cancel_text: 'Cancel'});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/surveys/send_survey', value);

			if (res.status != 'ERROR')
			{
				await Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully sent survey.')});
				this.page.updateData();
				Navbar.updateNotificationCount();
			}
			else
			Grape.alerts.alert({type: 'error', message: res.message, title: tr('Error')});
		}
		this.page.updateData();
	};

	async send_anonymous_survey(data)
	{
		let value = ko.mapping.toJS(data);
		value.emp_not_log_in = true;
		let res = await Grape.fetches.postJSON('/surveys/send_survey', value);

		if (res.status != 'ERROR')
			this.page.updateData();
		else
			Grape.alerts.alert({type: 'error', message: res.message, title: tr('Error')});

		this.page.updateData();
		return res;
	};

	delay(ms)
	{
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	async get_survey_qr_code(data)
	{
		let segments;
		try {
			let option = {
				table: 'segments',
				schema: 'savanna',
				limit: 1000000,
				offset: 0,
				sortorder: 'ASC',
				sortfield: 'segment_id'
			};
	
			let res = await Grape.fetches.getJSON('/api/record', option);
			if (res.status === 'OK')
				segments = res.records;
	
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			return;
		}

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Download QRcodes?'), message: tr('This will download a separate QRcode for each segment. After downloading, you will not be able to edit the questions'), accept_text: 'Proceed', cancel_text: 'Cancel'});
		if (response)
		{
			let value = ko.mapping.toJS(data);
			let res = await this.send_anonymous_survey(data);

			if (res.status == 'ERROR')
				return;

			try {
				// Iterate over each segment to generate and download QR codes
				for (let segment of segments)
				{
					let segment_id = segment.segment_id;
					let segment_name = segment.name.replace(/\s+/g, '_');

					let response = await fetch(`/open/survey_url_qr_code?survey_id=${value.survey_id}&segment_id=${segment_id}`);

					if (response.ok)
					{
						let qrBlob = await response.blob();
						let qrUrl = URL.createObjectURL(qrBlob);

						// download QR code
						let downloadLink = document.createElement('a');
						downloadLink.href = qrUrl;
						downloadLink.download = `survey_${value.title}_segment_${segment_name}_qr_code.png`;
						document.body.appendChild(downloadLink);
						downloadLink.click();
						document.body.removeChild(downloadLink);
					}
					else
						console.error(`Error fetching QR code for segment ${segment_name}:`, response.statusText);

					await this.delay(300);
				}
			} catch (error) {
				console.error('Network error:', error);
			}
		}
	}

	async delete_survey(v, e)
	{
		let data = ko.mapping.toJS(v);
		// set to false to deactivate
		data.active = false;
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this survey?')});
			
		if (response)
		{
			let res = await Grape.fetches.postJSON('/surveys/save_survey', data);

			if (res.status != 'ERROR')
			{
				await Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully deleted survey.')});
				this.page.updateData();
			}
			else
				Grape.alerts.apiError(res);
		}
	}

	show_survey_setup_help()
	{
		Grape.dialog.open('SurveySetupHelp', { employee_id: this.page.bindings.id });
	}

	show_anonymous_survey_setup_help()
	{
		Grape.dialog.open('AnonymousSurveySetupHelp', { employee_id: this.page.bindings.id });
	}
}

class SurveysSetupPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new SurveysSetupViewModel(this);
	}

	init()
	{
		document.title = tr('Surveys Setup');
		window.current_page_title(tr('Surveys Setup'));
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('api/record', {
			schema: 'savanna',
			table: 'v_surveys_list',
			limit: 1000000,
			filter: [
				{ value: true, operand: '=', field: 'active' }
			]
		});

		if (res.records)
		{
			let all_surveys = res.records;
			let surveys = all_surveys.filter(survey => survey.emp_not_log_in === true || survey.emp_not_log_in === null);
			let anonymous_surveys = all_surveys.filter(survey => survey.emp_not_log_in === false);

			this.viewModel.surveys(surveys);
			this.viewModel.anonymous_surveys(anonymous_surveys);
		}
	}
};

export default {
	route: '[/]admin/surveys_setup',
	page_class: SurveysSetupPage,
	template: template,
	template_filename: 'translation/surveys_setup'
};
